import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { GreenroomState } from '../../stores/types/types';
import ProfileTab from '../right-panel/user-menus/profile/profile';
import ProfileImages from '../right-panel/user-menus/profile/profile-images';
import useProfile from '../../hooks/use-profile';
import { loadMasks } from '../../stores/actions/masks';

const SideBySideContainer = styled.div`
	display: flex;
	margin: 0 auto 8px auto;
	gap: 72px;
	height: fit-content;
`;

interface Props {
	enterConferenceRoomFlow: () => void;
	next: () => void;
	nextButtonDisabled: boolean;
}

export default function ConfirmProfile({ enterConferenceRoomFlow, next, nextButtonDisabled }: Props) {
	const userId = useSelector((state: GreenroomState) => state.SessionReducer.user?.gr_user);
	const loadedMasks = useSelector((state: GreenroomState) => state.MasksReducer.loaded);
	const loadingProfile = useSelector((state: GreenroomState) => state.SessionReducer.loadingProfile);
	const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting?.meeting);
	const loadedFeatureFlags = useSelector((state: GreenroomState) => state.SettingsReducer.hasFetchedFFOverrides);
	const [loaded, setLoaded] = useState(false);
	const dispatch = useDispatch();

	const {watchedProfile, watchedIsMasked} = useProfile({suggestedProfile: userId});

	useEffect(() => {
		if (!loadedMasks && meeting) {
			dispatch(loadMasks(meeting));
		}
	}, [loadedMasks, meeting]);


	useEffect(() => {
		if (!loadedFeatureFlags) {
			setLoaded(false);
		} else if (!loadedMasks) {
			setLoaded(false);
		} else if (loadingProfile) {
			setLoaded(false);
		} else {
			setLoaded(true);
		}
	}, [loadedMasks, loadingProfile, loadedFeatureFlags]);

	return (!loaded ? null :
		<div className="panel teal-green confirm-info">
			<SideBySideContainer>
				<div style={{ maxWidth: '56%', width: '560px' }}>
					<ProfileImages displayedProfile={watchedProfile}></ProfileImages>
				</div>
				<div>
					<p className="header white-space-nowrap">Enter your profile information</p>
					<ProfileTab 
						profile={watchedProfile}
						isEditingMask={watchedIsMasked}
					></ProfileTab>
				</div>
			</SideBySideContainer>
			<div className='button-container'>
				<button onClick={() => enterConferenceRoomFlow()}>Use conference room</button>
				<button
					disabled={nextButtonDisabled}
					className='next-bttn-onboarding sherbert'
					onClick={next}>
						Continue
				</button>
			</div>
		</div>
	);
}
